import {DigitalSigningSnapshot} from "./public/digitalSigning.types";

const isRecord = (value: unknown): value is Record<string, unknown> => (
    !!value && typeof value === 'object' && !Array.isArray(value)
);

const hasAmounts = (value: unknown): value is Record<string, unknown> => (
    isRecord(value) && ['grossCents', 'netCents', 'vatCents'].every(key => Number.isSafeInteger(value[key]))
);

/** Restore ISO strings after the staff client's Date conversion; reject unreadable billing data. */
export const normalizeSnapshot = (snapshot: unknown): DigitalSigningSnapshot | undefined => {
    try {
        const parsed = typeof snapshot === 'string' ? JSON.parse(snapshot) : JSON.parse(JSON.stringify(snapshot ?? null));
        if (!isRecord(parsed)
            || !Array.isArray(parsed.lines) || !parsed.lines.every(hasAmounts)
            || !hasAmounts(parsed.totals)
            || !Array.isArray(parsed.totals.vatByRate) || !parsed.totals.vatByRate.every(hasAmounts)) {
            return undefined;
        }
        if (parsed.tip !== undefined && (!isRecord(parsed.tip)
            || !Array.isArray(parsed.tip.options)
            || !parsed.tip.options.every(option => isRecord(option)
                && Number.isSafeInteger(option.index) && Number.isSafeInteger(option.amountCents)))) {
            return undefined;
        }
        return parsed as unknown as DigitalSigningSnapshot;
    } catch {
        return undefined;
    }
};
